import { call, all, put, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import notification from '../../../services/notification';
import types from '../../types';

function* getCurrencies() {
  try {
    const { status, data } = yield call(api.market.currencies.getCurrencies);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_CURRENCIES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_CURRENCIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updateCurrencies({ payload }) {
  try {
    const { status, data } = yield call(
      api.market.currencies.updateCurrencies,
      payload,
    );
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_CURRENCIES_SUCCESS, payload: data });
    yield put({ type: types.GET_CURRENCIES_START });
  } catch (error) {
    yield put({ type: types.UPDATE_CURRENCIES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* currencies() {
  yield all([
    takeLatest(types.GET_CURRENCIES_START, getCurrencies),
    takeLatest(types.UPDATE_CURRENCIES_START, updateCurrencies),
  ]);
}
